"use strict";

var React = require('react'),
    DocumentTitle = require('react-document-title'),
    BS = require('react-bootstrap'),
    Footer = require('../toolbox/Footer'),
    ContactForm = require('../../partials/ContactForm'),
    CurrentUser = require('../../shared/CurrentUser'),
    cx = require('classnames');

var ErrorServiceLevel = React.createClass({displayName: "ErrorServiceLevel",

    contextTypes: {
        router: React.PropTypes.func
    },

    updateState: function() {
        var model = this.props.contactModel,
            query = this.context.router.getCurrentQuery();

        return {
            submitted: false,
            name: CurrentUser.getFullName(),
            email: CurrentUser.get('email'),
            code: 'toolbox',
            subject: 'Service Level Error',
            url: query.page,
            iframeHeight: 500
        };
    },

    getInitialState: function() {
        return this.updateState();
    },

    getDefaultProps: function() {
        return {};
    },

    /**
     * This is to ensure that when subroutes transistion they trigger recheck router state and render
     */
    componentWillReceiveProps: function() {
        this.setState(this.updateState());
    },

    render: function() {
        var me = this,
            props = me.props,
            state = me.state,
            project = props.project,
            projectName = project.get('name'),
            title = 'Agent Portal: ' + projectName + ': Error Service Level',
            height = '' + state.iframeHeight + 'px',
            contactFormProps = {
                onSubmit: me.onSubmit,
                name: state.name,
                email: state.email,
                code: state.code,
                subject: state.subject,
                url: state.url
            };

        return (
             React.createElement("div", {className: "wrapper"}, 
                React.createElement(DocumentTitle, {title: 'NCH - ' + title}), 
                React.createElement("div", {className: "container content"}, 
                    React.createElement("div", {className: "row"}, 
                        React.createElement("div", {className: "col-sm-8 col-sm-offset-2"}, 
                            React.createElement("h1", {className: "text-center"}, "Agent Portal for ", React.createElement("span", {className: "blue-text"}, projectName)), 
                            React.createElement("p", null, 
                                "Welcome agents and brokers to the agent program for ", React.createElement("span", {className: "blue-text"}, projectName), ". ", React.createElement("span", {className: "blue-text"}, projectName), " promotes and encourages the participation of real estate agents and brokers."
                            ), 
                            React.createElement("p", null, 
                                "The Agent Portal serves as the hub for the agent program. Log in to access exclusive tools and information to help you market and promote ", React.createElement("span", {className: "blue-text"}, projectName), " to all your buyers."
                            ), 
                            React.createElement("p", null, 
                                "The Agent Portal is not currently available for ", React.createElement("span", {className: "blue-text"}, projectName), ". ", React.createElement("span", {className: "blue-text"}, projectName), " has not upgraded their account to include this feature. Would you like to use this feature? Complete the form below and we will reach out to ", React.createElement("span", {className: "blue-text"}, projectName), " to suggest they upgrade their Agent Portal."
                            ), 
                            React.createElement("p", {className: "margin-bottom-20"}, 
                                "Need help? ", React.createElement("a", {href: "#", onClick: this.showHelp}, "Click Here"), "."
                            )
                        )
                    ), 
                    React.createElement("div", {className: "row"}, 
                        React.createElement("div", {className: "col-sm-6 col-sm-offset-3"}, 
                            state.submitted ? (
                                React.createElement(BS.Panel, {className: "panel-split-header", bsStyle: "success", header: (React.createElement("h2", null, "Thank You!"))}, 
                                    "Thank you for contacting New Construction Hub."
                                )
                            ) : (
                                React.createElement(BS.Panel, {className: "panel-split-header", bsStyle: "danger", header: (React.createElement("h2", null, "Service Level Error!"))}, 
                                    "We apologize but this service is not currently available.", 

                                    React.createElement("div", {className: "headline"}, 
                                        React.createElement("h2", null, "Please complete the form below to help us fix the problem.")
                                    ), 
                                    React.createElement("iframe", {key: "servicelevel-form", allowTransparency: "true", src: "https://secure.jotformpro.com/form/60943721593157", frameBorder: "0", style: { width:'100%', height:height, border:'none'}, scrolling: "no"})
                                )
                            ), 
                            React.createElement(Footer, {trackerId: "agent-toolbox-error-service-level"})
                        )
                    )
                )
            )
        );
    },

    onSubmit: function(model) {
        this.setState({
            submitted: true
        });
    },

    handleSizeResponse: function(e) {
        var originalEvent = e.originalEvent,
            data = e.originalEvent.data;
        if (originalEvent.origin == 'https://secure.jotformpro.com') {
            data = data.split(':');
            if (data[0] === 'setHeight') {
                this.setState({
                    iframeHeight: data[1]
                });
            }
        }
    }
});
module.exports = ErrorServiceLevel;
